import { defineComponent as _defineComponent } from 'vue'
import BCXCard from '@/components/molecules/BCXCard.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import Chevron from '@/components/svg-components/Chevron.vue';
import useInfoBoxState from '@/state/infoBox';
import ByteCookieIcon from '@/components/svg/logo/logo-circles-only.svg?inline';
import {
  computed, ref, watch
} from 'vue';
import { sample } from 'lodash';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardInfoBox',
  setup(__props) {

const { tUserFallback: t } = useUser('self');
const { infoBoxState } = useInfoBoxState();
const currentTipIndex = ref(0);

const resolvedTexts = computed(() => {
  if (!infoBoxState.text) return [];
  const textOrTexts = t(infoBoxState.text);
  if (!textOrTexts) return [];
  return Array.isArray(textOrTexts) ? textOrTexts : [textOrTexts];
});

const showTipNavigation = computed(() => !!infoBoxState.enableTipNavigation && resolvedTexts.value.length > 1);

const text = computed(() => {
  if (!resolvedTexts.value.length) return '';
  if (showTipNavigation.value) return resolvedTexts.value[currentTipIndex.value] as string;
  return sample(resolvedTexts.value) as string;
});

const headline = computed(() => t(infoBoxState.headline));

const goToPreviousTip = () => {
  if (!resolvedTexts.value.length) return;
  currentTipIndex.value = currentTipIndex.value === 0
    ? resolvedTexts.value.length - 1
    : currentTipIndex.value - 1;
};

const goToNextTip = () => {
  if (!resolvedTexts.value.length) return;
  currentTipIndex.value = currentTipIndex.value === resolvedTexts.value.length - 1
    ? 0
    : currentTipIndex.value + 1;
};

watch([() => infoBoxState.text, resolvedTexts], () => {
  if (!resolvedTexts.value.length) {
    currentTipIndex.value = 0;
    return;
  }
  if (showTipNavigation.value) {
    currentTipIndex.value = Math.floor(Math.random() * resolvedTexts.value.length);
  }
});


return { __sfc: true,t, infoBoxState, currentTipIndex, resolvedTexts, showTipNavigation, text, headline, goToPreviousTip, goToNextTip, BCXCard, BCXMarkdown, Chevron, ByteCookieIcon }
}

})